import { SessionNotesTemplate } from '../../../enums/enums';
import { defaultNotesTemplate } from '../fixtures/content';
import { readStorage, storageKeys, writeStorage } from '../support/storage';

interface DevMockNote {
  id: string;
  notes: string;
}

const noteStorageKey = (userId: string, groupId: string) => `${userId}:${groupId}`;

/**
 * Returns the note template for the given key.
 */
export function getDevMockNotesTemplate(templateKey: SessionNotesTemplate): string {
  return templateKey === SessionNotesTemplate.OneOnOneNotesTemplate ? defaultNotesTemplate(1) : defaultNotesTemplate(2);
}

/**
 * Returns the mock notes for a user and group.
 */
export function getDevMockNotes(userId: string, groupId: string, participantCount: number): DevMockNote {
  const noteMap = readStorage<Record<string, DevMockNote>>(storageKeys.notes, {});
  const key = noteStorageKey(userId, groupId);
  const existingNote = noteMap[key];

  if (existingNote) {
    return existingNote;
  }

  return {
    id: `note-${key}`,
    notes: defaultNotesTemplate(participantCount)
  };
}

/**
 * Saves mock notes for a user and group.
 */
export function saveDevMockNotes(userId: string, groupId: string, notes: string): DevMockNote {
  const noteMap = readStorage<Record<string, DevMockNote>>(storageKeys.notes, {});
  const key = noteStorageKey(userId, groupId);
  const nextNote = {
    id: noteMap[key]?.id ?? `note-${key}`,
    notes
  };

  noteMap[key] = nextNote;
  writeStorage(storageKeys.notes, noteMap);
  return nextNote;
}
